// b99.9.82 — Centralised responsive config for TripOverviewMap.
// Single source of truth for inline (minimised, lives inside the
// public trip sheet column) vs fullscreen (portal-mounted, takes
// over the whole viewport).
//
// Every "fullscreen ? X : Y" branch that used to litter the
// component now reads from here. Add a new responsive knob? Define
// it once for both variants and consumers fetch it via `getMapCfg`.

export const TRIP_MAP_CONFIG = {
  inline: {
    // FitBounds asymmetric padding (px). Top is larger to give the
    // start/finish marker icon (~44 px above anchor) + label tooltip
    // (~28 px) headroom even when the anchor sits at the top edge of
    // the bounds.
    padTop: 56,
    padBottom: 24,
    padX: 16,
    maxZoom: 16,
    // Elevation panel chart height (px) — compact in tight column.
    elevationHeight: 100,
    // Tooltip toggle default — OFF in inline so the small map isn't
    // cluttered (trip-level start/finish tooltips use `alwaysVisible`
    // so they stay regardless).
    tooltipsDefault: false,
    // Mobile auto-shrink factor — applied if `inlineHeightPxMobile`
    // isn't explicitly passed.
    mobileShrinkFactor: 0.7,
  },
  fullscreen: {
    padTop: 80,
    padBottom: 50,
    padX: 40,
    maxZoom: 14,
    elevationHeight: 140,
    tooltipsDefault: true,
  },
};

export function getMapCfg(fullscreen) {
  return fullscreen ? TRIP_MAP_CONFIG.fullscreen : TRIP_MAP_CONFIG.inline;
}
